export const sellerOptions = data => (data.sellers || []).map(seller => (
  { value: seller.id, label: seller.fullDisplayName }
));

export const stringOptions = values => (values || []).map(value => (
  { value, label: value }
));

export const saleOptions = data => (data.sales || []).map(sale => (
  { value: sale.id, label: sale.name }
));

export const buyerOptions = data => (data.buyers || []).map(buyer => (
  { value: buyer.id, label: buyer.fullDisplayName }
));

export const locationOptions = data => (data.locations || []).map(location => (
  {
    value: location.id,
    label: `${location.city}, ${location.state} - ${location.street}`,
  }
));

export const paddleServiceOptions = data => (
  (data.paddleServices || []).map(paddleService => (
    { value: paddleService.id, label: paddleService.name }
  ))
);
